import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=b304b572"
import script from "./SubmitButton.ts?vue&type=script&lang=ts&external"
export * from "./SubmitButton.ts?vue&type=script&lang=ts&external"
import style0 from "./Styles/submit-button.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports